import * as React from "react";

interface UseIntervalProps {
	callback: () => void;
	delay: number | null;
}

const useInterval = ({ callback, delay }: UseIntervalProps) => {
	const savedCallback = React.useRef(callback);

	// Remember the latest callback
	React.useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	// Set up the interval
	React.useEffect(() => {
		if (delay === null) {
			return;
		}

		const tick = () => {
			savedCallback.current();
		};

		const id = setInterval(tick, delay);
		return () => clearInterval(id);
	}, [delay]);
};

export default useInterval;
